const require_runtime = require('../../_virtual/_rolldown/runtime.cjs');

//#region src/types/plugins/SharePlugin.ts
var SharePlugin_exports = /* @__PURE__ */ require_runtime.__exportAll({});

//#endregion
Object.defineProperty(exports, 'SharePlugin_exports', {
  enumerable: true,
  get: function () {
    return SharePlugin_exports;
  }
});
//# sourceMappingURL=SharePlugin.cjs.map